import { GridCellProps } from '@progress/kendo-react-grid';
import { SHToolTip } from 'app/components/SHToolTip';
import styled from 'styled-components';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e: any) => void;
};

const ShowRiderStateCell = ({ className, e, onClick }: Props) => {
  const data = e?.dataItem;
  return (
    <td className={className ?? ''} onClick={onClick}>
      <SHToolTip position="top">
        <ContactWrapper title={data?.state}>
          {data?.state}
        </ContactWrapper>
      </SHToolTip>
    </td>
  );
};

export default ShowRiderStateCell;
const ContactWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  min-width: 120px;
  max-width: 200px;
`;
